import getSymbolFromCurrency from "currency-symbol-map";
import { Dispatch, SetStateAction } from "react";
import _ from "underscore";
import Constants from "./Constants";
import { WidgetType } from "../types/DashboardInterfaces";

type LayoutBreakpoints = ["lg", "md", "sm", "xs", "xxs"];
type Layouts = { lg: any; md: any; sm: any; xs: any; xxs: any };

// breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
// cols={{ lg: 12, md: 8, sm: 4, xs: 2, xxs: 1 }}
export const getNewWidgetLayouts = (id: string, type: WidgetType) => {
  if (type === "Header") {
    return {
      lg: {
        i: id,
        x: 0,
        y: 0,
        w: 6,
        h: 1,
        minW: 2,
      },
      md: {
        i: id,
        x: 0,
        y: 0,
        w: 4,
        h: 1,
        minW: 1,
      },
      sm: {
        i: id,
        x: 0,
        y: 0,
        w: 2,
        h: 1,
        minW: 2,
      },
      xs: {
        i: id,
        x: 0,
        y: 0,
        w: 2,
        h: 1,
      },
      xxs: {
        i: id,
        x: 0,
        y: 0,
        w: 1,
        h: 1,
      },
    };
  }

  if (type === "Table") {
    return {
      lg: {
        i: id,
        x: 0,
        y: 0,
        w: 6,
        h: 3,
        minW: 4,
        minH: 3,
      },
      md: {
        i: id,
        x: 0,
        y: 0,
        w: 4,
        h: 3,
        minW: 4,
        minH: 3,
      },
      sm: {
        i: id,
        x: 0,
        y: 0,
        w: 2,
        h: 3,
        minW: 2,
        minH: 3,
      },
      xs: {
        i: id,
        x: 0,
        y: 0,
        w: 2,
        h: 3,
        minW: 1,
        minH: 3,
      },
      xxs: {
        i: id,
        x: 0,
        y: 0,
        w: 1,
        h: 3,
        minH: 3,
      },
    };
  }

  if (type === "SingleStat") {
    return {
      lg: {
        i: id,
        x: 0,
        y: 0,
        w: 2,
        h: 3,
        minW: 2,
        minH: 2,
      },
      md: {
        i: id,
        x: 0,
        y: 0,
        w: 2,
        h: 3,
        minW: 2,
        minH: 2,
      },
      sm: {
        i: id,
        x: 0,
        y: 0,
        w: 2,
        h: 3,
        minW: 2,
        minH: 2,
      },
      xs: {
        i: id,
        x: 0,
        y: 0,
        w: 2,
        h: 3,
        minW: 1,
        minH: 2,
      },
      xxs: {
        i: id,
        x: 0,
        y: 0,
        w: 1,
        h: 3,
        minH: 2,
      },
    };
  }

  if (type === "Document") {
    return {
      lg: {
        i: id,
        x: 0,
        y: 0,
        w: 6,
        h: 3,
        minW: 3,
        minH: 2,
      },
      md: {
        i: id,
        x: 0,
        y: 0,
        w: 4,
        h: 3,
        minW: 3,
        minH: 2,
      },
      sm: {
        i: id,
        x: 0,
        y: 0,
        w: 2,
        h: 3,
        minW: 2,
        minH: 2,
      },
      xs: {
        i: id,
        x: 0,
        y: 0,
        w: 2,
        h: 3,
        minW: 1,
        minH: 2,
      },
      xxs: {
        i: id,
        x: 0,
        y: 0,
        w: 1,
        h: 3,
        minH: 2,
      },
    };
  }

  return {
    lg: {
      i: id,
      x: 0,
      y: 0,
      w: 6,
      h: 3,
      minW: 3,
      minH: 3,
    },
    md: {
      i: id,
      x: 0,
      y: 0,
      w: 4,
      h: 3,
      minW: 3,
      minH: 3,
    },
    sm: {
      i: id,
      x: 0,
      y: 0,
      w: 2,
      h: 3,
      minW: 2,
      minH: 3,
    },
    xs: {
      i: id,
      x: 0,
      y: 0,
      w: 2,
      h: 3,
      minW: 1,
      minH: 3,
    },
    xxs: {
      i: id,
      x: 0,
      y: 0,
      w: 1,
      h: 3,
      minH: 3,
    },
  };
};

export const handleLockedWidth = (
  sectionID: string,
  lockWidth: number,
  layouts: Layouts,
  setUpdate: Dispatch<SetStateAction<boolean>>,
  handleLayoutChange: (newLayout: any, allLayouts: Layouts) => void
) => {
  const breakpoints: LayoutBreakpoints = ["lg", "md", "sm", "xs", "xxs"];
  const newLayouts = { ...layouts };
  let changeOccurred = false;

  for (const breakpoint of breakpoints) {
    if (newLayouts.hasOwnProperty(breakpoint) && !!lockWidth) {
      // lockWidth is set, ensure width is locked for this section
      const foundLayout = _.findWhere(newLayouts[breakpoint], {
        i: sectionID,
      });

      if (!foundLayout) {
        newLayouts[breakpoint].push({
          h: 1,
          i: sectionID,
          maxW: lockWidth,
          minW: lockWidth,
          w: lockWidth,
          x: 0,
          y: 0,
        });

        changeOccurred = true;
        continue;
      }

      // Check to see if lockWidth is up to date with layouts
      if (
        foundLayout?.w !== lockWidth ||
        foundLayout?.minW !== lockWidth ||
        foundLayout?.maxW !== lockWidth
      ) {
        foundLayout.w = lockWidth;
        foundLayout.minW = lockWidth;
        foundLayout.maxW = lockWidth;
        changeOccurred = true;
      }
    } else if (newLayouts.hasOwnProperty(breakpoint) && !lockWidth) {
      // lockWidth is null, ensure width isn't locked for this section
      const foundLayout = _.findWhere(newLayouts[breakpoint], {
        i: sectionID,
      });

      if (
        foundLayout?.hasOwnProperty("minW") ||
        foundLayout?.hasOwnProperty("maxW")
      ) {
        delete foundLayout.minW;
        delete foundLayout.maxW;
        changeOccurred = true;
      }
    } else if (!newLayouts.hasOwnProperty(breakpoint) && !!lockWidth) {
      // lockWidth is set, but breakpoint doesn't exist in layouts yet
      newLayouts[breakpoint] = [
        {
          h: 1,
          i: sectionID,
          maxW: lockWidth,
          minW: lockWidth,
          w: lockWidth,
          x: 0,
          y: 0,
        },
      ];
      changeOccurred = true;
    }
  }

  if (changeOccurred) {
    setUpdate(true);
    handleLayoutChange(_, newLayouts);
  }
};

export const handleLockedHeight = (
  sectionID: string,
  lockHeight: number,
  layouts: Layouts,
  setUpdate: Dispatch<SetStateAction<boolean>>,
  handleLayoutChange: (newLayout: any, allLayouts: Layouts) => void
) => {
  const breakpoints: LayoutBreakpoints = ["lg", "md", "sm", "xs", "xxs"];
  const newLayouts = { ...layouts };
  let changeOccurred = false;

  for (const breakpoint of breakpoints) {
    if (newLayouts.hasOwnProperty(breakpoint) && !!lockHeight) {
      // lockHeight is set, ensure height is locked for this section
      const foundLayout = _.findWhere(newLayouts[breakpoint], {
        i: sectionID,
      });

      if (!foundLayout) {
        newLayouts[breakpoint].push({
          h: lockHeight,
          i: sectionID,
          maxH: lockHeight,
          minH: lockHeight,
          w: 1,
          x: 0,
          y: 0,
        });

        changeOccurred = true;
        continue;
      }

      // Check to see if lockHeight is up to date with layouts
      if (
        foundLayout?.h !== lockHeight ||
        foundLayout?.minH !== lockHeight ||
        foundLayout?.maxH !== lockHeight
      ) {
        foundLayout.h = lockHeight;
        foundLayout.minH = lockHeight;
        foundLayout.maxH = lockHeight;
        changeOccurred = true;
      }
    } else if (newLayouts.hasOwnProperty(breakpoint) && !lockHeight) {
      // lockHeight is null, ensure height isn't locked for this section
      const foundLayout = _.findWhere(newLayouts[breakpoint], {
        i: sectionID,
      });

      if (
        foundLayout?.hasOwnProperty("minH") ||
        foundLayout?.hasOwnProperty("maxH")
      ) {
        delete foundLayout.minH;
        delete foundLayout.maxH;
        changeOccurred = true;
      }
    } else if (!newLayouts.hasOwnProperty(breakpoint) && !!lockHeight) {
      // lockHeight is set, but breakpoint doesn't exist in layouts yet
      newLayouts[breakpoint] = [
        {
          h: lockHeight,
          i: sectionID,
          maxW: lockHeight,
          minW: lockHeight,
          w: 1,
          x: 0,
          y: 0,
        },
      ];
      changeOccurred = true;
    }
  }

  if (changeOccurred) {
    setUpdate(true);
    handleLayoutChange(_, newLayouts);
  }
};

export const handleWidgetDefaults = (widget: any) => {
  switch (widget.Type) {
    case "Table":
      widget.Query = {
        Fields: ["_RecordName", "id"],
        Filters: [],
        Pagination: {
          Count: 25,
          Page: 1,
        },
      };
      widget.Prefills = [];
      widget.ShowToolbar = true;
      return;
    case "BarChart":
      widget.Orientation = "Vertical";
      return;
    case "GroupedBarChart":
      widget.Orientation = "Vertical";
      widget.ChartStyle = "Stacked";
      return;
    case "ProgressBarChart":
      widget.Orientation = "Bar";
      return;
    case "Header":
      widget.Size = "h2";
      widget.Alignment = "center";
      return;
    default:
      return;
  }
};

export const typeUsesChartSettings = (type: string) => {
  return (
    type === "PieChart" ||
    type === "DonutChart" ||
    type === "BarChart" ||
    type === "GroupedBarChart" ||
    type === "ProgressBarChart" ||
    type === "LineChart" ||
    type === "GroupedLineChart" ||
    type === "FilledLineChart" ||
    type === "StageFunnel" ||
    type === "SingleStat"
  );
};

// TODO: Add query type
export const isValidChartQuery = (
  query: any,
  fieldTypeMap: { [key: string]: string }
): boolean => {
  if (
    (fieldTypeMap[query?.GroupBy?.Field] === "Date" ||
      fieldTypeMap[query?.GroupBy?.Field] === "DateTime") &&
    !query?.GroupBy?.Interval
  ) {
    return false;
  }

  return (
    query?.GroupBy?.Field &&
    query?.Aggregations?.[0]?.Method &&
    query?.Aggregations?.[0]?.Field
  );
};

export const isValidGroupedChartQuery = (query: any) => {
  const xAxisField = query?.GroupBy?.[1]?.Field;
  const groupByField = query?.GroupBy?.[0]?.Field;
  const aggregationField = query?.Aggregations?.[0]?.Field;
  const aggregationMethod = query?.Aggregations?.[0]?.Method;

  if (!xAxisField || !groupByField) {
    return false;
  }

  if (xAxisField === groupByField) {
    return false;
  }

  if (!aggregationField || !aggregationMethod) {
    return false;
  }

  return true;
};

export const isValidMapQuery = (query: any) => {
  return query?.Fields?.length;
};

export const isValidSingleStatQuery = (query: any) => {
  return query?.Aggregations?.[0]?.Method && query?.Aggregations?.[0]?.Field;
};

export const isValidLineChartQuery = (query: any) => {
  return true;
};

export const isValidProgressQuery = (query: any): boolean => {
  return query?.Aggregations?.[0]?.Method && query?.Aggregations?.[0]?.Field;
};

// TODO: Add currency
export const currencyToReadable = (val: any): any => {
  if (!val) {
    return "---";
  }

  if (!val.Currency) {
    return "(unknown currency)";
  }

  let currency = getSymbolFromCurrency(val.Currency);

  if (!currency) {
    return "(unknown currency)";
  }

  let formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: val.Currency,
  });

  return `${formatter.format(parseFloat(val.Value))} ${
    val.Interval ? " / " + val.Interval + "." : ""
  }`;
};

export const timeFrameFormatting = {
  second: "MMMM Do YYYY, h:mm:ss a",
  minute: "MMMM Do YYYY, h:mm a",
  hour: "MMMM Do YYYY, h a",
  day: "MMMM Do YYYY",
  month: "MMMM YYYY",
  year: "YYYY",
};

export const timeFrameData = [
  { label: "Second", value: "second" },
  { label: "Minute", value: "minute" },
  { label: "Hour", value: "hour" },
  { label: "Day", value: "day" },
  { label: "Month", value: "month" },
  { label: "Year", value: "year" },
];

export const getReadableAggregationMethod = (method: string) => {
  switch (method) {
    case "Count":
      return "Number";
    case "Avg":
      return "Average";
    default:
      return method;
  }
};

const getAcceptableWidgetKeys = (type: string) => {
  const defaultKeys = ["Name", "Description"];

  switch (type) {
    case "PieChart":
      return [...defaultKeys];
    case "DonutChart":
      return [...defaultKeys];
    case "BarChart":
      return [...defaultKeys];
    case "LineChart":
      return [...defaultKeys];
    case "FilledLineChart":
      return [...defaultKeys];
    case "SingleStat":
      return [...defaultKeys];
    case "Document":
      return [...defaultKeys];
    case "Table":
      return [...defaultKeys];
    default:
      return [...defaultKeys];
  }
};

// https://awik.io/determine-color-bright-dark-using-javascript/
const lightOrDark = (color: any) => {
  if (!color) return "light";

  // Variables for red, green, blue values
  let r, g, b, hsp;

  // Check the format of the color, HEX or RGB?
  if (color.match(/^rgb/)) {
    // If RGB --> store the red, green, blue values in separate variables
    color = color.match(
      /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
    );

    r = color[1];
    g = color[2];
    b = color[3];
  } else {
    // If hex --> Convert it to RGB: http://gist.github.com/983661
    color = +("0x" + color.slice(1).replace(color.length < 5 && /./g, "$&$&"));

    r = color >> 16;
    g = (color >> 8) & 255;
    b = color & 255;
  }

  // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
  hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
  // Using the HSP value, determine whether the color is light or dark
  if (hsp > 127.5) {
    return "light";
  } else {
    return "dark";
  }
};

const light = "#ffffff";
const dark = "#000000";

export const getTextColor = (
  color: string | undefined,
  darkColor?: string,
  lightColor?: string
) => {
  const result = lightOrDark(color);
  const finalDarkColor = darkColor ? darkColor : dark;
  const finalLightColor = lightColor ? lightColor : light;

  return result === "light" ? finalDarkColor : finalLightColor;
};

export const getHoverColor = (color: any) => {
  if (!color) return "";

  // Variables for red, green, blue values
  let r, g, b, hsp;

  // Check the format of the color, HEX or RGB?
  if (color.match(/^rgb/)) {
    // If RGB --> store the red, green, blue values in separate variables
    color = color.match(
      /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
    );

    r = color[1];
    g = color[2];
    b = color[3];
  } else {
    // If hex --> Convert it to RGB: http://gist.github.com/983661
    color = +("0x" + color.slice(1).replace(color.length < 5 && /./g, "$&$&"));

    r = color >> 16;
    g = (color >> 8) & 255;
    b = color & 255;
  }

  return `rgb(${r - 15 > 0 ? r - 15 : 0}, ${g - 15 > 0 ? g - 15 : 0}, ${
    b - 15 > 0 ? b - 15 : 0
  })`;
};

export const isValidProgressChart = (widget: any) => {
  if (!isValidProgressQuery(widget.Query)) {
    return false;
  }

  if (!widget?.Target) return false;

  return true;
};

export const sanitizeWidget = (widget: any) => {
  const widgetType = widget.Type;
  const widgetKeys = Object.keys(widget);

  // Temp until we have all widget keys defined.
  return;

  const acceptableKeys = getAcceptableWidgetKeys(widgetType);

  const keysToDelete = _.difference(widgetKeys, acceptableKeys);

  for (let i = 0; i < keysToDelete.length; i++) {
    delete widget[keysToDelete[i]];
  }
};
